// This is a global event bus to make components talk to each other.
// Dont misuse this. For more complex matters use VUEX

import mitt from 'mitt';
const emitter = mitt();

// fix no dollar-sign in mitt library
emitter.$on = emitter.on;
emitter.$emit = emitter.emit;

export const eventBus = emitter;

// import Vue from 'vue';
// export const eventBus = new Vue();
